module.exports = __webpack_public_path__ + "media/images/flags/32/Guatemala-68c70b26af86dfb8d02cefbfb1b31549.png";